import React from 'react';
import { OrderedMap, set } from 'immutable';
import axios from 'axios';

export const useProductsAndQuotation = (quotationId) => {
  const [quotation, setQuotation] = React.useState(undefined);
  const [products, setProducts] = React.useState(undefined);
  const [totals, setTotals] = React.useState({credit: 0, cash: 0});
  const [allItensPrice, setAllItensPrice] = React.useState(false);
  const [refreshVersion, setRefreshVersion] = React.useState(0);

  React.useEffect(() => {
    setTotals({ credit: 0, cash: 0 });
    setAllItensPrice(false);
    axios.get(`/api/v1/quotations/${quotationId}/`)
      .then(({ data }) => {
        const items = new OrderedMap(data.items.map((item) => ([item.id, {
          id: item.id,
          comment: item.comment,
          images: item.images,
          quantity: item.quantity,
          quality_level: item.quality_level ? item.quality_level : null,
          name: item.product ? item.product.name : item.custom_product,
          image: item.product ? item.product.cover_image : null,
          is_sealed: item.is_sealed,
          quoted_price: item.quoted_price,
        }])));

        const calculatedTotals = data.items.reduce((sum, item) => {
          if (!item.quoted_price) return sum;
          const quantity = item.quantity || 1;
          return {
            credit: sum.credit + (parseFloat(item.quoted_price.credit) * quantity),
            cash: sum.cash + (parseFloat(item.quoted_price.cash) * quantity),
          };
        }, { credit: 0, cash: 0 });
        setTotals(calculatedTotals);

        const allItemsHavePrice = data.items.every(item => item.quoted_price !== null);

        if (allItemsHavePrice) {
          setAllItensPrice(true);
        }

        setProducts(items);
        setQuotation(data);
      })
      .catch((err) => {
        if (err.response && err.response.status === 404) {
          setQuotation(null);
          setProducts(null);
        }
      });
  }, [quotationId, refreshVersion]);

  return {
    quotation,
    products,
    totals,
    setQuotation,
    setProducts,
    allItensPrice,
    refresh: () => setRefreshVersion((version) => version + 1),
  };
};

export const useClientOrigins = () => {
  const [clientOrigins, setClientOrigins] = React.useState([]);

  React.useEffect(() => {
    axios.get('/api/v1/client-origins/')
      .then(({ data }) => {
        const options = data.map((obj) => ({
          key: obj.id,
          text: obj.name,
          value: obj.id,
        }));
        setClientOrigins(options);
      });
  }, []);

  return { clientOrigins };
};
